import { Injectable, inject } from '@angular/core';
import { AUTH_REMEMBER_STORAGE_KEY, AUTH_TOKENS_STORAGE_KEY } from '@shared/constants/storage-keys.const';
import { WebStorageService } from '@shared/storage/web-storage.service';
import { AuthTokenStorage } from './auth-token-storage';
import { AuthTokens } from './auth-tokens.model';

@Injectable()
export class HybridAuthTokenStorage implements AuthTokenStorage {
  private readonly storage = inject(WebStorageService);

  private get rememberMe(): boolean {
    return this.storage.getItem(AUTH_REMEMBER_STORAGE_KEY) === 'true';
  }

  public setRememberMe(value: boolean): void {
    if (value) {
      this.storage.setItem(AUTH_REMEMBER_STORAGE_KEY, 'true');
    } else {
      this.storage.removeItem(AUTH_REMEMBER_STORAGE_KEY);
    }
  }

  public async load(): Promise<AuthTokens | null> {
    const area = this.rememberMe ? 'local' : 'session';
    const raw = this.storage.getItem(AUTH_TOKENS_STORAGE_KEY, area);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AuthTokens;
    } catch {
      this.clearAll();
      return null;
    }
  }

  public async save(tokens: AuthTokens): Promise<void> {
    const json = JSON.stringify(tokens);
    const area = this.rememberMe ? 'local' : 'session';
    this.storage.setItem(AUTH_TOKENS_STORAGE_KEY, json, area);
  }

  public async clear(): Promise<void> {
    this.clearAll();
    this.storage.removeItem(AUTH_REMEMBER_STORAGE_KEY);
  }

  private clearAll(): void {
    this.storage.removeItem(AUTH_TOKENS_STORAGE_KEY, 'local');
    this.storage.removeItem(AUTH_TOKENS_STORAGE_KEY, 'session');
  }
}
